export default __webpack_public_path__ + "static/media/Chestplate of the Ostiary.94044c06.jpg";